module.exports = __webpack_public_path__ + "img/08706145000971.2c6f244d.png";